export const messages_it = {
  "header.home": "Home",
  "header.about": "Chi siamo",
  "header.services": "Servizi",
  "header.contacts": "Contatti",
  "header.login": "Accedi",
  "header.language": "Lingua",
  "footer.legalNotes": "Note legali",
  "footer.privacyPolicy": "Privacy Policy",
  "footer.cookiePolicy": "Cookie Policy",

  //ROUTE /login
  "login.title": "REVENGE",
  "login.subtitle":
    "ECU FILE SERVICE IN A FLASH",
  "login.paragraph":
    " ",
  "login.button.contact": "Contattaci",
  "login.form.title": "Accedi",
  "login.form.username": "Username",
  "login.form.email": "Email",
  "login.form.password": "Password",
  "login.form.rememberMe": "Ricordami",
  "login.form.submit": "Accedi",
  "login.form.forgotPassword": "Hai dimenticato la password?",
  "login.form.or": "Oppure",
  "login.form.requestAccess": "Richiedi l'accesso",
  "login.form.warnings.field":
    "Il nome utente o la password che hai inserito non è corretto, riprova",
  "login.form.warnings.empty": "Campo obbligatorio",
  "login.form.warnings.email": "Email non valida",
  "login.proceed": "Puoi ora procedere al login.",

  // request access form
  "register.title": "Richiedi accesso all'amministratore",
  "register.form.firstname": "Nome",
  "register.form.lastname": "Cognome",
  "register.form.email": "Email",
  "register.form.company": "Ragione Sociale",
  "register.form.address": "Indirizzo",
  "register.form.city": "Città",
  "register.form.zip": "Codice postale",
  "register.form.country": "Nazione",
  "register.form.vat": "P.IVA o codice fiscale",
  "register.form.phone": "Telefono",
  "register.form.isSlave": "Sono uno Slave",
  "register.form.submit": "Invia",
  "register.form.warnings.field": "Valore non valido",
  "register.form.warnings.empty": "Campo obbligatorio",
  "register.form.warnings.number.type": "Inserisci un valore numerico",
  "register.form.error":
    "Errore nel caricamento del modulo. Per favore, ricontrolla i dati inseriti e riprova.",
  "register.form.success": "Richiesta inviata con successo.",
  "register.form.success.message":
    " Riceverai una mail contenente le istruzioni per completare la registrazione.",

  // PASSWORD
  "password.requirements":
    "La nuova password deve contenere almeno 8 caratteri, di cui almeno una lettera maiuscola, una minuscola, un numero e un carattere speciale tra questi @, $, !, %, *, ?, &",
  "password.minimum": "La password deve contenere almeno 8 caratteri",
  "password.match": "Le password non corrispondono",
  "password.error.reset":
    "Errore nel reset della password, per favore riprova.",
  "forgotPassword.title":
    "Inserisci il tuo indirizzo email per ricevere le istruzioni per il recupero della password.",
  "forgotPassword.requestAccess": "Non sei registrato? Richiedi l'accesso",
  "forgotPassword.error":
    "L'email inserita non è corretta, per favore riprova.",
  "forgotPassword.success": "Controlla la tua casella email. Grazie!",

  // ROUTE /contacts
  "contacts.title": "Contattaci",
  "contacts.subtitle":
    "Se hai domande o dubbi, puoi lasciare un messaggio qui. Ti risponderemo al più presto.",
  "contacts.form.firstname": "Nome",
  "contacts.form.lastname": "Cognome",
  "contacts.form.email": "Email",
  "contacts.form.message": "Il tuo messaggio",
  "contacts.form.disclaimer": "Cliccando Invia dichiari di accettare la nostra",
  "contacts.form.privacy": "Privacy Policy",
  "contacts.form.cookie": "Cookie Policy",
  "contacts.form.end": "e",
  "contacts.form.submit": "Invia",
  "contacts.form.submitted": "Inviato!",
  "contacts.form.success": "Grazie per averci contattato, a presto!",
  "contacts.form.warnings.email": "Inserisci un indirizzo email valido",
  "contacts.form.warnings.empty": "Campo obbligatorio",
  "contacts.form.warnings.max": "Inserisci massimo 50 caratteri",
  "contacts.form.warnings.min": "Inserisci almeno 2 caratteri",

  // General items
  "dashboard.header.credits": "Totale crediti residui",
  "dashboard.header.buyCredits": "Acquista crediti",
  "dashboard.review.projects": "Le mie lavorazioni",
  "dashboard.review.tickets": "I miei tickets",
  "dashboard.review.tickets.open": "Aperti",
  "dashboard.review.tickets.closed": "Chiusi",
  "dashboard.review.tickets.inProgress": "In corso",
  "dashboard.review.tickets.completed": "Completati",
  "dashboard.review.project.new": "Nuove",
  "dashboard.review.project.inProgress": "In corso",
  "dashboard.review.project.pending": "In attesa",
  "dashboard.review.project.failed": "Fallite",
  "dashboard.review.project.refunded": "Rimborsate",
  "dashboard.review.project.completed": "Completate",
  "dashboard.review.addProjectTitle": "Aggiungi una nuova lavorazione",
  "dashboard.review.addProjectSubtitle":
    "Clicca qui per iniziare a registrare una nuova lavorazione sul veicolo. Sarai guidato attraverso i passaggi necessari per definire i dettagli e le specifiche della modifica o del lavoro da eseguire.",
  "dashboard.sidebar.dashboard": "Dashboard",
  "dashboard.sidebar.users": "Utenti",
  "dashboard.sidebar.tickets": "Tickets",
  "dashboard.sidebar.operations": "Lavorazioni",
  "dashboard.sidebar.profile": "Profilo",
  "dashboard.sidebar.settings": "Impostazioni",
  "dashboard.sidebar.support": "Supporto",
  "dashboard.sidebar.logout": "Esci",
  "dashboard.internalSidebar.welcome": "Benvenuto",
  "dashboard.internalSidebar.help": "Hai bisogno di aiuto?",
  "dashboard.internalSidebar.guide": "Scarica la nostra guida",
  "dashboard.totalUsers": "Totali utenti",
  "dashboard.totalNewProjects": "Nuove lavorazioni",
  "dashboard.totalOpenTickets": "Tickets aperti",
  "dashboard.recentUsers": "Utenti recenti",
  "dashboard.recentUsers.subtitle": "Ultimi utenti registrati",
  "dashboard.recentTickets": "Tickets recenti",
  "dashboard.recentTickets.subtitle": "Ultimi tickets inseriti",
  "dashboard.completedProjects": "Lavorazioni completate",
  "dashboard.completedProjects.current": "Anno corrente",
  "dashboard.completedProjects.previous": "Anno precedente",

  // TABLES
  "table.noData": "Nessun dato disponibile",
  "table.header.status": "Stato",
  "table.header.created": "Creato il",
  "table.header.updated": "Modificato il",
  "table.header.type": "Veicolo",
  "table.header.brand": "Marca",
  "table.header.model": "Modello",
  "table.header.category": "Categoria",
  "table.header.companyName": "Ragione Sociale",
  "table.header.details": "Dettagli",
  "table.header.title": "Titolo",
  "table.header.firstName": "Nome",
  "table.header.lastName": "Cognome",
  "table.header.email": "Email",
  "table.header.phone": "Telefono",
  "table.header.actions": "Azioni",
  "table.header.sent": "Inviato da",

  //STATUS
  "status.open": "Aperto",
  "status.closed": "Chiuso",
  "status.pending": "In attesa",
  "status.completed": "Completato",
  "status.inProgress": "In corso",
  "status.refunded": "Rimborsato",
  "status.failed": "Fallito",
  "status.new": "Nuovo",
  "status.active": "Attivo",
  "status.banned": "Bloccato",

  //BUTTONS
  "button.back": "Indietro",
  "button.confirm": "Conferma",
  "button.create": "Crea",
  "button.save": "Salva",
  "button.details": "Dettagli",
  "button.createTicket": "Crea Ticket",
  "button.startChat": "Avvia la chat",
  "button.send": "Invia",
  "button.newProject": "Nuova lavorazione",
  "button.filter": "Filtra",
  "button.filter.manual": "Filtra tra i progetti inseriti manualmente",
  "button.contactUs": "Contattaci",
  "button.backHome": "Torna alla Home",
  "button.reply": "Rispondi",
  "button.insert.vehicleInfo":
    "Inserisci le informazioni del veicolo manualmente",
  "button.modifyOrder": "Modifica l'ordine",
  "button.search": "Cerca...",
  "button.addCreditTier": "Aggiungi fascia di crediti",
  "button.remove": "Rimuovi",
  "button.viewAll": "Visualizza tutti",
  "button.cancel": "Annulla",
  "button.add": "Aggiungi",
  "button.show": "Mostra di più",
  "button.delete": "Elimina",
  "button.update": "Aggiorna",
  "button.hide": "Nascondi",
  "button.close": "Chiudi",
  // USERS
  "users.title": "Gestione utenti",
  "users.subtitle": "Visualizza e gestisci tutti gli utenti iscritti",
  "users.projects.title": "Lavorazioni",
  "users.userData": "Visualizza la scheda utente",
  "users.updateStatus": "Aggiorna lo stato dell'utente",
  "users.update": "Aggiorna elenco",
  "users.singleUser": "Utente",
  "users.temporaryPassword": "Password temporanea",
  "users.temporaryPassword.sent": "Password inviata il",
  "users.status": "Stato",
  "users.addCredits.title": "Aggiungi crediti all'utente",
  "users.addCredits.reason": "Scegli una motivazione",
  "users.reason.notSpecified": "Non specificato",
  "users.reason.welcome": "Bonus di benvenuto",
  "users.reason.refund": "Rimborso",

  //PROJECT
  "project.title.plural": "Lavorazioni",
  "project.title.singular": "Lavorazione",
  "project.created": "Creato il",
  "project.updated": "Modificato il",
  "project.type": "Tipo veicolo",
  "project.status": "Stato",
  "project.brand": "Marca",
  "project.model": "Modello",
  "project.generation": "Generazione",
  "project.gearbox": "Cambio",
  "project.year": "Anno",
  "project.engine": "Motore",
  "project.fuel": "Carburante",
  "project.engineHp": "Potenza del motore",
  "project.readingMethod": "Metodo di lettura",
  "project.ecuBrand": "Marca ECU",
  "project.ecuName": "Nome ECU",
  "project.ecuType": "Tipo ECU",
  "project.services": "Servizi (Opzioni extra)",
  "project.dtc": "DTC esclusi",
  "project.dtc.achronym": "DTC (Diagnostic Trouble Codes)",
  "project.file": "File allegato",
  "project.modFile": "File MOD lavorato",
  "project.noModFile": "Nessun file MOD presente.",
  "project.tickets": "Tickets collegati",
  "project.noTickets": "Nessun ticket collegato a questa lavorazione.",
  "project.new": "Nuova lavorazione",
  "project.select.type": "Scegli il tipo di veicolo",
  "project.select.brand": "Scegli la marca",
  "project.select.model": "Scegli il modello",
  "project.select.generation": "Scegli la generazione",
  "project.select.engine": "Scegli il motore",
  "project.select.engineHp": "Scegli la potenza del motore",
  "project.select.year": "Scegli l'anno",
  "project.select.gearbox": "Scegli il cambio",
  "project.select.fuel": "Scegli il carburante",
  "project.select.ecuBrand": "Scegli la marca dell'ECU",
  "project.select.ecuName": "Scegli il nome dell'ECU",
  "project.select.ecuType": "Scegli il tipo di ECU",
  "project.select.readingMethod": "Scegli il metodo di lettura",
  "project.select.notFound":
    "Non ho trovato le informazioni relative al mio veicolo all'interno dei menù",
  "project.insert.vehicleInfo":
    "Inserisci le informazioni del veicolo manualmente",
  "project.total.services": "Totale servizi",
  "project.total": "Totale",
  "project.service": "Servizio",
  "project.price": "Prezzo",
  "project.dtc.select": "Digita il codice DTC che desideri disattivare",
  "project.new.modal": "Hai selezionato servizi per un totale di",
  "project.new.modal.services":
    "Hai selezionato questi servizi per la tua lavorazione:",
  "project.new.modal.missing.start": "Ti servono",
  "project.new.modal.missing.end": "per completare la lavorazione",
  "project.modal.continue": "Per continuare, modifica la tua scelta oppure",
  "project.modal.buy": "clicca qui per acquistare ulteriori crediti",
  "project.modal.credits": "verranno scalati",
  "project.updateStatus": "Aggiorna lo stato della lavorazione",

  //CREDITI
  credit: "credito",
  credits: "crediti",
  "credits.title": "Acquista crediti",
  "credits.prices": "Prezzi",
  "credits.tiers": "Fasce di crediti acquistabili",
  "credits.unitPrice": "prezzo unitario",
  "credits.bar":
    "Scorri la barra per selezionare il numero di crediti desiderato",
  "credits.selected": "Crediti selezionati",
  "credits.total": "Totale",
  "credits.specialPrice": "Prezzo speciale",

  //ORDER
  "order.new": "Nuovo ordine",
  "order.vat": "di cui IVA",
  "order.total": "Totale",
  "order.success": "Grazie! Il tuo ordine è stato completato con successo.",
  "order.confirm": "Riceverai una email di conferma a breve.",
  "order.error": "Si è verificato un errore durante il pagamento.",
  "order.error.paypal": "Il pagamento non è stato eseguito.",

  // TICKET
  "ticket.help": "Creare un nuovo ticket accedendo ad una lavorazione",
  "ticket.title.singular": "Ticket",
  "ticket.title.plural": "Tickets",
  "ticket.status": "Stato",
  "ticket.category": "Categoria",
  "ticket.created": "Creato il",
  "ticket.sent": "Inviato da",
  "ticket.attachment": "Allegato",
  "ticket.resolutionDate": "Data di risoluzione stimata",
  "ticket.noResolutionDate": "Nessuna data di risoluzione indicata.",
  "ticket.communications": "Comunicazioni",
  "ticket.noMessages": "Nessun messaggio presente.",
  "ticket.type": "Scrivi un messaggio...",
  "ticket.new.title": "Nuovo Ticket",
  "ticket.new.project": "Lavorazione collegata",
  "ticket.new.name": "Titolo del ticket",
  "ticket.new.category": "Categoria del ticket",
  "ticket.new.description": "Descrizione del ticket",
  "ticket.new.description.max": "Massimo 500 caratteri",
  "ticket.new.attachment": "Allegato",

  // FILE
  "file.attach": "Clicca qui oppure trascina un file per allegarlo",
  "file.attach.admin": "Clicca qui per allegare il file lavorato",
  "file.attach.user": "Clicca qui per allegare il file da lavorare *",
  "file.formats": "Formati accettati:",
  "file.noFile": "Nessun file caricato",
  "file.size.error": "Il file è troppo grande. Massimo 10 MB",
  "file.toBeProcessed": "File da lavorare allegato dallo user ",

  //TOOLTIP
  "tooltip.downloadFile": "Clicca per scaricare il file",
  "tooltip.uploadFile":
    "Clicca per caricare un file in formato .zip, .mod o .bin, Max 10 MB",
  "tooltip.viewTicket": "Clicca per visualizzare il ticket",
  "tooltip.temporaryPassword":
    "La password temporanea sarà inviata all'utente, il quale la dovrà modificare al primo accesso.",

  //PROFILE
  "profile.tab1": "Modifica profilo",
  "profile.tab2": "Sicurezza",
  "profile.createNewPassword": "Crea una nuova password",
  "profile.confirmNewPassword": "Conferma la nuova password",

  // FAQ
  "faq.title": "Domande frequenti (FAQ)",
  "faq.new": "Nuova FAQ",
  "faq.question": "Domanda",
  "faq.answer": "Risposta",
  "faq.noFaqs": "Nessuna FAQ presente.",
  "faq.create": "Crea una nuova domanda",
  "faq.delete": "Sei sicuro di voler eliminare la domanda",
  "faq.edit": "Modifica la domanda",

  //SETTINGS
  "settings.title": "Impostazioni",
  "settings.listing.credits": "Listino valori Crediti",
  "settings.listing.credits.min": "Min. soglia",
  "settings.listing.credits.max": "Max. soglia",
  "settings.listing.credits.price": "Prezzo unitario",
  "settings.listing.credits.special": "E' un prezzo speciale",
  "settings.listing.services": "Listino prezzi Servizi",
  "settings.listing.services.service": "Servizio",
  "settings.listing.services.price": "Prezzo in crediti",

  //SNACKBAR
  "snackbar.correctValueStep":
    "Correggere uno o più valori delle soglie maggiori",
  "snackbar.unitPrice": "Prezzo unitario mancante",
  "snackbar.validStep":
    "Inserisci un valore valido per lo step all'interno della sezione Listino valori crediti",
  "snackbar.file.format":
    "Formato file non valido. Caricare un file .zip, .mod oppure .bin",
  "snackbar.project.success": "Lavorazione aggiornata con successo.",
  "snackbar.project.error":
    "Errore durante l'aggiornamento della lavorazione, per favore riprova.",
  "snackbar.copied": "Copiato negli appunti",
  "snackbar.form": "Compilare tutti i campi contrassegnati da * (asterisco)",
  "snackbar.fields": "E' necessario compilare tutti i campi",
  "snackbar.manual.vehicleInfo": "Inserire marca e modello del veicolo",

  //ALERT
  "alert.loadingError": "Errore durante il caricamento",
};
